<template>
    <li>
        <div class="tit">
            <span class="ct_a">{{ datasrcCateNm }}</span>
            <span class="ct_b">{{ datasrc.origin.originNm }}</span>
            {{ datasrc.dataSrcNm }}
        </div>
        <div class="txt">{{ apiEndpointDsc }}</div>
        <a v-if="!!mnlUrl && $_WC.viewScale < 2 && !$_WC.isMobile && datasrc.dwldPermYn == '1'" @click.prevent="prepareExcel(datasrc)" class="btn_down">다운로드 <i></i></a>
        <a v-if="!!mnlUrl && $_WC.viewScale < 2" :href="mnlUrl" target="_blank" class="btn_link">바로가기 <i></i></a>
    </li>
</template>

<script>
import {mapGetters} from "vuex";
import { $_WC } from '@/confs/common.const.js';
import commonApi from "@/apis/common.api";
// import * as Xlsx from 'xlsx/xlsx.mjs';
// xlsx fork 버전인 xlsxJsStyle 모듈 사용
import * as Xlsx from 'xlsx-js-style';


export default {
    data() {
        return {
            regex: /[^0-9]/g,
        }
    },
    props: {
        datasrc: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapGetters({
            datasrcList: 'getDatasrcList',
            datasrcCateMap: 'getDatasrcCateMap',
            openapiEndpointMap: 'getOpenapiEndpointMap',
        }),
        datasrcCate(){
            return this.datasrc.cates[0].dataCateCd;
        },
        datasrcCateNm(){
            return this.datasrcCateMap[this.datasrcCate].localeTitle;
        },
        apiInfo(){
            return this.openapiEndpointMap[this.datasrc.dataKdSqno];
        },
        mnlUrl() {
            let mnlUrl = '';
            if(!!this.apiInfo.mnlUrl){
                mnlUrl = this.apiInfo.mnlUrl.replaceAll('&amp;', '&');
            }
            return mnlUrl;
        },
        apiEndpointDsc(){
            return !!this.apiInfo.apiEndpointDsc ? this.apiInfo.apiEndpointDsc : '-';
        },
    },
    methods: {
        prepareExcel(datasrc) {
            this.$eventBus.$emit('Change::Loader::State', true);
            // 제공데이터
            let dtDsc = datasrc.dataKd.dtDsc;
            let dtDscNm = this.setDtDscName(dtDsc);
            let dwldPdCd = datasrc.dwldPdCd;
            commonApi.fetchDataKdHdngList(datasrc.dataKdSqno).then(res => {
                // 자료항목 조회
                // console.log('res', res.data.data);
                let dataHdngKdList = res.data.data;

                // 데이터 검색 조건에 따른 searchFromDate 설정.
                let today = new Date();
                let searchFromDate;
                let q;

                if(dwldPdCd == 'whole') {
                    q = '';
                } else {
                    if(dwldPdCd == 'day') {
                        let oneDay = new Date(today - (3600000 * 24 * 1));
                        searchFromDate = oneDay.format('yyyyMMdd') + '0000';
                    } else if(dwldPdCd == 'month') {
                        let oneMonth = new Date(today - (3600000 * 24 * 30));
                        searchFromDate = oneMonth.format('yyyyMMdd') + '0000';
                    } else if(dwldPdCd == 'quarter') {
                        let quarter = new Date(today - (3600000 * 24 * 90));
                        searchFromDate = quarter.format('yyyyMMdd') + '0000';
                    } else if(dwldPdCd == 'half') {
                        let half = new Date(today - (3600000 * 24 * 180));
                        searchFromDate = half.format('yyyyMMdd') + '0000';
                    } else if(dwldPdCd == 'year') {
                        let year = new Date(today - (3600000 * 24 * 365));
                        searchFromDate = year.format('yyyyMMdd') + '0000';
                    }
                    q = 'searchFromDate=' + searchFromDate;
                }
                
                commonApi.fetchRepoDataList(datasrc.dataKdSqno, q).then((response) => {
                    let dataList = response.data.data;
                    // 실제 호출 데이터
                    // console.log('response', response.data.data);
                    dataList.forEach((data) => {
                        // 우선 필요없는 항목 제거(일련번호, 자료종류번호, 반영전 일련번호, 최종변경일, 위경도)
                        delete data.amnDataSqno;
                        delete data.dataKdSqno;
                        delete data.rflbDataSqno;
                        delete data.updt;
                        delete data.lttdVal;
                        delete data.lgtdVal;

                        // 기준일 설정
                        if(!!data['basdtVal']) {
                            let basdtValue = data['basdtVal'];
                            delete data['basdtVal'];
                            data['기준일('+ dtDscNm +')'] = basdtValue;
                        }

                        // 속성 명을 화면항목명으로 변경
                        dataHdngKdList.forEach((hdng) => {
                            let val;
                            if(!!data[hdng.dataHdngColnm]) {
                                val = data[hdng.dataHdngColnm];
                                delete data[hdng.dataHdngColnm];
                                data[hdng.scrnHdngnm] = val;
                            }
                        });


                    })
                    // 항목명 변경한 데이터 확인
                    // console.log('dataList', dataList);

                    if(!!dataList) {
                        this.downloadExcelData(dataList, datasrc.dataKd.dataKdTit);
                    }
                });
            });
        },
        downloadExcelData(dataList, datakdTit) {
            if(!!dataList) {
                let workBook = Xlsx.utils.book_new();
                let workSheet = Xlsx.utils.json_to_sheet(dataList);
                
                console.log('workSheet', workSheet);
                // excel style 변경 필요.
                let regex = this.regex;
                for(let key in workSheet) {
                    if(!['!ref'].includes(key)) {
                        let keyNum = key.replace(regex, "");
                        console.log('key', keyNum);
                        workSheet[key].s = {
                            font: {
                                name: "Malgun Gothic",
                            },
                            alignment: {
                                vertical: "center",
                                horizontal: "center",
                                wrapText: '1',
                            },
                            border: {
                                left: {style:"thin", color: "#000000"},
                                right: {style:"thin", color: "#000000"},
                                top: {style:"thin", color: "#000000"},
                                bottom: {style:"thin", color: "#000000"},
                            },
                        }
                        if(keyNum == 1) {
                            workSheet[key].s.font.bold = true;
                            workSheet[key].s.fill = {
                                    patternType: "solid",
                                    fgColor: { rgb: "e8f0f8" }
                            }
                        }
                    }
                }

                Xlsx.utils.book_append_sheet(workBook, workSheet, 'Sheet1');
                Xlsx.writeFile(workBook, datakdTit + '.xlsx');
                this.$eventBus.$emit('Change::Loader::State', false);
            }
        },
        setDtDscName(dtDsc) {
            let dtDscNm = '';
            if(dtDsc == 'ymd') {
                dtDscNm = '년월일';
            } else if(dtDsc == 'ym') {
                dtDscNm = '년월';
            } else if(dtDsc == 'yq') {
                dtDscNm = '년분기';
            } else if(dtDsc == 'y') {
                dtDscNm = '년';
            } else if(dtDsc == 'ymdh') {
                dtDscNm = '년월일시';
            } else if(dtDsc == 'ymdhm') {
                dtDscNm = '년월일시분';
            } else if(dtDsc == 'ymdhms') {
                dtDscNm = '년월일시분초';
            }
            return dtDscNm;            
        },
    }
}
</script>
